import {useCallback, useEffect, useState} from "react";
import {SEARCH_HISTORY_MAX_LENGTH, SEARCH_HISTORY_STORAGE_KEY} from "../constants";

export const useSearchHistory = () => {
    const [history, setHistory] = useState<string[]>([]);

    /**
     * Сохранение в localStorage
     */
    const persistHistory = useCallback((data: string[]) => {
        localStorage.setItem(SEARCH_HISTORY_STORAGE_KEY, JSON.stringify(data));
    }, []);

    /**
     * Инициализация из localStorage
     */
    useEffect(() => {
        try {
            const saved = JSON.parse(
                localStorage.getItem(SEARCH_HISTORY_STORAGE_KEY) ?? "[]"
            );

            if (Array.isArray(saved)) {
                setHistory(saved);
            }
        } catch {
            setHistory([]);
        }
    }, []);

    /**
     * Сохранение истории
     */
    const saveHistory = useCallback((data: string[]) => {
        setHistory(data);

        persistHistory(data);
    }, []);

    /**
     * Добавить поисковую фразу
     */
    const addSearchTerm = useCallback(
        (term: string) => {
            const normalizedTerm = term.trim();

            if (!normalizedTerm) {
                return;
            }

            setHistory((prev) => {
                let next = prev.filter((item) => item.toLowerCase() !== normalizedTerm.toLowerCase());

                next.unshift(normalizedTerm);

                if (next.length > SEARCH_HISTORY_MAX_LENGTH) {
                    next = next.slice(0, SEARCH_HISTORY_MAX_LENGTH);
                }

                persistHistory(next);

                return next;
            });
        },
        []
    );

    /**
     * Удалить одну запись
     */
    const removeTerm = useCallback(
        (term: string) => {
            setHistory((prev) => {
                const next = prev.filter(
                    (item) => item !== term
                );

                persistHistory(next);

                return next;
            });
        },
        []
    );

    /**
     * Очистить историю
     */
    const clearHistory = useCallback(() => {
        saveHistory([]);
    }, [saveHistory]);

    return {
        history,
        addSearchTerm,
        removeTerm,
        clearHistory,
    };
};
